import { Button, HStack, Input, Stack, Text, VStack } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { adminLogIn, saveAuthTokens } from "../../api";
import LogOutOnly from "../../components/Auth/LogOutOnly";
import { useAuthStore } from "../../store";
import { colors } from "../../styles";

export default function LogIn() {

    /* navigate */

    const navigate = useNavigate();

    /* useAuthStore */

    const { setIsLoggedIn, setIsAdmin, setIsGuest } = useAuthStore();

    /* useForm */

    interface ILogInForm {
        email: string;
        password: string;
    }

    const { register, handleSubmit, formState: { errors }, watch } = useForm<ILogInForm>();

    /* isValidEmail 함수 */
    
    const isValidEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(email) {
            return emailRegex.test(email);
        }
        return false;
      };
    
    const isEmailFilledRight = isValidEmail(watch("email"));

    /* onSubmit */

    const onSubmit = async ({ email, password } : ILogInForm) => {

        if(!isEmailFilledRight) return;
        await adminLogInMutation.mutateAsync({ email, password });
    }

    /* adminLogInMutation */

    const adminLogInMutation = useMutation({
        mutationFn: adminLogIn,
        onSuccess: async (data) => {
            const { server_token, refresh_token } = data;

            if (server_token && refresh_token) {
                await saveAuthTokens(server_token, refresh_token);
            }

            ///////////////////////////////////////////////////////////////////////// 로그인 상태 저장

            setIsLoggedIn(true);
            setIsAdmin(true);
            setIsGuest(false);

            ///////////////////////////////////////////////////////////////////////// 네비게이트
            
            navigate("/admin/main");
        },
        onError: (error) => {
            console.log("error!", error);
        }
    })

    /* 렌더링 */

    return (
        <LogOutOnly>
            <VStack 
                justifyContent={"center"} 
                alignItems={"center"} 
                padding={10}
                height={"100vh"}
            >
                <Stack 
                    as="form" 
                    // onSubmit={handleSubmit(onSubmit)} 
                    width={{
                        base:"100%",
                        sm:"90%",
                        md:"60%",
                        lg:"40%",
                        xl:"40%"
                    }} 
                    marginTop={-100}
                >

                    {/* 로그인 타이틀 */}

                    <HStack  
                        padding={1} 
                        width={"100%"} 
                        justifyContent={"space-between"}
                    >
                        <Text fontSize={28} fontWeight={700} color={colors.g1}>🚀 관리자 로그인</Text>
                    </HStack>

                    {/* 이메일 입력 */}

                    <Stack marginTop={5}>
                        <Text fontSize="sm" color={colors.blue}>
                            이메일 주소
                        </Text>
                        <Input 
                            {...register("email", {required:true})} 
                            type="text" 
                            isInvalid={Boolean(errors.email?.message)} 
                            placeholder={"관리자 아이디 입력"} 
                            borderBottom={`1px solid ${colors.g4}`} 
                            borderTop="none" 
                            borderLeft="none" 
                            borderRight="none" 
                            borderRadius="0" 
                            _focus={{
                                borderBottom: `1px solid ${colors.blue}`,
                                boxShadow: "none",
                                outline: "none"
                            }}
                        />
                    </Stack>

                    {/* 비밀번호 입력 */}

                    <Stack marginTop={5}>
                        <Text fontSize="sm" color={colors.blue}>
                            비밀번호
                        </Text>
                        <Input 
                            {...register("password", {required:true})} 
                            type="password" 
                            isInvalid={Boolean(errors.password?.message)} 
                            placeholder={"비밀번호"} 
                            borderBottom={`1px solid ${colors.g4}`}
                            borderTop="none" 
                            borderLeft="none" 
                            borderRight="none" 
                            borderRadius="0"
                            _focus={{
                                borderBottom: `1px solid ${colors.blue}`,
                                boxShadow: "none",
                                outline: "none"
                            }}
                        />
                    </Stack>

                    {/* 로그인 버튼 */}
                    
                    <Button 
                        type="submit" 
                        isLoading={adminLogInMutation.isPending} 
                        size={"md"} 
                        width="100%" 
                        marginTop={5}
                        backgroundColor={colors.blue} 
                        color={colors.white} 
                        _hover={{ bg: colors.blue }} 
                        boxShadow="sm"
                        disabled={!isEmailFilledRight}
                        onClick={handleSubmit(onSubmit)}
                    > 
                        로그인 
                    </Button>
                </Stack>
            </VStack>
        </LogOutOnly>
    )
}